export default __webpack_public_path__ + "static/media/stat-acquired-deals.92a67e9b.svg";